<template>
  <div class="wl-container">
    <div class="wl-content-container">

      <!-- 搜索框 -->
      <div class="wl-search-bar">
        <div class="wl-left">
          <el-date-picker v-model="dateRange"
                          type="daterange"
                          :range-separator="$t('SITE_TO')"
                          value-format="yyyy-MM-dd"
                          :start-placeholder="$t('SITE_START_DATE')"
                          :picker-options="options"
                          :clearable="false"
                          :end-placeholder="$t('SITE_END_DATE')"
                          class="input-with-select">
          </el-date-picker>
        </div>

        <div class="wl-right">

          <el-button class="wl-green svg-btn"
                     @click="downloadTrace"><img src="@/assets/img/icon-export.svg" class="btn-icon" width="100%" />{{$t('COMMON_EXPORT')}} </el-button>

        </div>
      </div>

      <!-- 表格 -->
      <div class="table-container-wrapper">
        <el-table height="100%"
                  v-loading="loading"
                  :data="data"
                  border
                  stripe>

          <el-table-column type="index"
                           width="70"></el-table-column>

          <el-table-column prop="operUrl"
                           :label="$t('AUDIT_TRAIL_TABLE_HEADER_ACCESS_URL')"
                           show-overflow-tooltip
                           width="200"></el-table-column>

          <el-table-column prop="operIp"
                           :label="$t('AUDIT_TRAIL_TABLE_HEADER_OPERATION_IP')"></el-table-column>

          <el-table-column prop="userAgent"
                           show-overflow-tooltip
                           :label="$t('AUDIT_TRAIL_TABLE_HEADER_USER_AGENT')"></el-table-column>

          <el-table-column prop="operType"
                           :label="$t('AUDIT_TRAIL_TABLE_HEADER_USER_TYPE')"></el-table-column>

          <el-table-column prop="operator"
                           :label="$t('AUDIT_TRAIL_TABLE_HEADER_OPERATOR')"></el-table-column>

          <el-table-column prop="operLog"
                           :label="$t('AUDIT_TRAIL_TABLE_HEADER_OPERATION_LOG')"></el-table-column>

          <el-table-column prop="operTime"
                           :label="$t('AUDIT_TRAIL_TABLE_HEADER_OPERATION_TIME')"></el-table-column>

        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination class="wl-pagination"
                     :current-page="pagination.pageNum"
                     :page-size="pagination.pageSize"
                     @current-change="onCurrentPageChange"
                     @size-change="onSizeChange"
                     :page-sizes="[10, 50, 100]"
                     layout="prev, pager, next, sizes, total"
                     :total="pagination.total"></el-pagination>

    </div>
  </div>
</template>
<script>
import API from '@/api'
import { dateFormat, isIE, loading } from '@/utils'
import { mapGetters } from 'vuex'
import { decrypt } from '@/utils/rsaEncrypt'
export default {
    name: 'user',
    data() {
        return {
            data: [],
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            loading: false,
            dateRange: [],
            options: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                }
            }
        }
    },
    mounted() {
        const now = Date.now(),
            lastMonth = now - 1000 * 60 * 60 * 24 * 30

        this.dateRange = [new Date(lastMonth), new Date(now)]

        this.getStaffList()
    },
    methods: {
        onSizeChange(size) {
          this.pagination.pageSize = size
          this.pagination.pageNum = 1
          this.getStaffList()
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getStaffList()
        },
        async downloadTrace() {
            let service = loading()
            try {
                service.download()
                const res = await API.system.exportAduitTrail({
                    startQueryTime: this.dateRange && this.dateRange[0] ? dateFormat(new Date(this.dateRange[0]), 'yyyy-MM-dd') : '',
                    endQueryTime: this.dateRange && this.dateRange[1] ? dateFormat(new Date(this.dateRange[1]), 'yyyy-MM-dd') : ''
                })
                if (/application\/json/.test(res.type)) {
                    let reader = new FileReader()
                    reader.onload = e => {
                        if (e.target.readyState === 2) {
                            let resJson = {}
                            resJson = JSON.parse(e.target.result)
                            this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                        }
                    }
                    reader.readAsText(res)
                } else 
                if (/application\/octet-stream/.test(res.type)) {
                
                    let blob = new Blob([res])
                    if (isIE()) {
                        navigator.msSaveBlob(blob, 'AuditTrail.xlsx')
                    } else {
                        let url = window.URL.createObjectURL(blob)
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', 'AuditTrail.xlsx')
                        document.body.appendChild(link)
                        link.click()
                    }
                }
            }
            catch(e) {}
            finally {
                service.close()
            }
        },
        getStaffList: async function() {
            try {
                this.loading = true
                const params = {
                    ...this.pagination,
                    startQueryTime: this.dateRange && this.dateRange[0] ? dateFormat(new Date(this.dateRange[0]), 'yyyy-MM-dd') : '',
                    endQueryTime: this.dateRange && this.dateRange[1] ? dateFormat(new Date(this.dateRange[1]), 'yyyy-MM-dd') : ''
                }

                const result = await API.system.queryAuditTrail(params)
                const res = result? JSON.parse(decrypt(result)) : null
                if (res.code == '1') {
                    this.data = _.map(res.data.records, v => ({
                        ...v,
                        operTime: dateFormat(new Date(v.operTimeStamp))
                    }))
                    this.pagination.total = res.data.total
                    this.loading = false
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }
            catch(e) {}
            finally {
                this.loading = false
            }
        }
    },
    computed: {
        ...mapGetters('common', {
            user: 'getUser'
        })
    },
    watch: {
        dateRange() {
            this.onCurrentPageChange(1)
        }
    }
}
</script>

<style scoped>
.wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}
.wl-content-container {
    background: #fff;
    height: 100%;
    padding: 22px 22px 16px 22px;
  border-radius: 8px;
}
.wl-search-bar {
    height: 45PX;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.wl-left,
.wl-right {
    display: flex;
    justify-content: flex-start;
    justify-items: center;
}
</style>
